import InfomindsAnalytics from '@infominds/react-native-analytics'
import { IM, IMLayout } from '@infominds/react-native-components'
import { useStorageMigration } from '@infominds/react-native-license'
import React, { useEffect } from 'react'
import { LogBox, Platform, StatusBar, useWindowDimensions } from 'react-native'
import { SafeAreaProvider } from 'react-native-safe-area-context'

import { languageResources } from './assets/languages/LanguageResources'
import AuthenticationWrapper from './components/AuthenticationWrapper'
import Colors from './constants/Colors'
import { firebaseConfig } from './constants/FirebaseConfigWeb'
import { SettingsProvider } from './contexts/SettingsContext'
import InitStructures from './InitStructures'
import Navigation from './navigation'

export default function App() {
  const { fontScale } = useWindowDimensions()
  const migrated = useStorageMigration({ isExpensesApp: false })

  useEffect(() => {
    InfomindsAnalytics.init(firebaseConfig)

    if (Platform.OS !== 'web') {
      LogBox.ignoreAllLogs(true)
    }
  }, [])

  if (migrated === undefined) return <></>
  if (migrated === false) console.error('🛑 Migration failed!')

  return (
    <IM.ThemeProvider>
      <IM.AlertProvider>
        <IM.ThemeContext.Consumer>
          {context => (
            <IM.LanguageProvider resources={languageResources}>
              <SafeAreaProvider key={fontScale}>
                <SettingsProvider>
                  <AuthenticationWrapper>
                    {({ authReady, isLoggedIn }) => (
                      <>
                        <InitStructures />
                        {authReady ? (
                          <Navigation isLoggedIn={isLoggedIn} />
                        ) : (
                          <IM.View style={[IMLayout.flex.f1, { justifyContent: 'center', backgroundColor: context?.theme.background }]}>
                            {Platform.OS !== 'web' && <IM.LoadingSpinner isVisible />}
                          </IM.View>
                        )}
                        <StatusBar
                          backgroundColor={Colors[context ? context.colorScheme : 'light'].background}
                          barStyle={context?.colorScheme === 'dark' ? 'light-content' : 'dark-content'}
                        />
                      </>
                    )}
                  </AuthenticationWrapper>
                </SettingsProvider>
              </SafeAreaProvider>
            </IM.LanguageProvider>
          )}
        </IM.ThemeContext.Consumer>
      </IM.AlertProvider>
    </IM.ThemeProvider>
  )
}
